import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { User } from '../models/user.model';
import { Role } from '../models/role.model';
import { globalCacheBusterNotifier } from 'ngx-cacheable';

@Injectable()
export class AuthService {

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  private user: User;
  private loggedIn: boolean;

  constructor(private api: ApiService) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(sessionStorage.getItem('user')));
    this.currentUser = this.currentUserSubject.asObservable();
    this.currentUser.subscribe(currentUser => {
      this.loggedIn = !!(currentUser);
      this.user = currentUser;
    });
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(login: string, password: string) {
    return new Promise(((resolve, reject) => {
      return this.api.postData('auth/token', {login, password}).subscribe(result => {
        const token = result.headers.get('Authorization');
        sessionStorage.setItem('token', token);
        this.api.getUserDetails().subscribe((user: User) => {
          sessionStorage.setItem('user', JSON.stringify(user));
          this.currentUserSubject.next(user);
          resolve(user);
        });
      }, error => reject(error));
    }));
  }

  logout() {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('user');
    globalCacheBusterNotifier.next();
    this.currentUserSubject.next(null);
  }

  get isAdmin() {
    return this.user && this.user.authorityNames.includes(Role.Admin);
  }

  get isLoggedIn() {
    return this.loggedIn;
  }

}
